import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from '../components/ui/button';
import { Home, ArrowLeft, Search, Mail } from 'lucide-react';

export const NotFoundPage = () => {
  return (
    <div className="min-h-screen flex items-center justify-center px-6" style={{ backgroundColor: '#F0E0D0' }}>
      <div className="max-w-2xl mx-auto text-center">
        {/* 404 Number */}
        <div className="mb-8">
          <h1 className="text-9xl font-bold mb-4" style={{ color: '#A060B0' }}>
            404
          </h1>
          <h2 className="text-3xl md:text-4xl font-bold mb-4" style={{ color: '#303040' }}>
            Page Not Found
          </h2>
          <p className="text-xl mb-8" style={{ color: '#708080' }}>
            The page you're looking for doesn't exist or has been moved.
          </p>
        </div>

        {/* Helpful Links */}
        <div className="grid md:grid-cols-2 gap-4 mb-12">
          <Link to="/">
            <Button 
              size="lg" 
              className="w-full text-lg px-6 py-6"
              style={{ backgroundColor: '#A060B0', color: 'white' }}
            >
              <Home className="mr-2 h-5 w-5" />
              Go to Homepage
            </Button>
          </Link>
          <Link to="/countries">
            <Button 
              size="lg" 
              variant="outline"
              className="w-full text-lg px-6 py-6"
              style={{ borderColor: '#708080', color: '#708080' }}
            >
              <Search className="mr-2 h-5 w-5" />
              Browse Countries
            </Button>
          </Link>
        </div>

        {/* Quick Navigation */}
        <div className="bg-white rounded-2xl p-8 shadow-lg">
          <h3 className="text-xl font-bold mb-6" style={{ color: '#303040' }}>
            Popular Pages
          </h3>
          <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
            <Link to="/services" className="text-center p-4 rounded-lg hover:bg-gray-50 transition-colors">
              <p className="font-semibold" style={{ color: '#708080' }}>Services</p>
            </Link>
            <Link to="/countries" className="text-center p-4 rounded-lg hover:bg-gray-50 transition-colors">
              <p className="font-semibold" style={{ color: '#708080' }}>Countries</p>
            </Link>
            <Link to="/success-packs" className="text-center p-4 rounded-lg hover:bg-gray-50 transition-colors">
              <p className="font-semibold" style={{ color: '#708080' }}>Success Packs</p>
            </Link>
            <Link to="/contact" className="text-center p-4 rounded-lg hover:bg-gray-50 transition-colors">
              <p className="font-semibold" style={{ color: '#708080' }}>Contact</p>
            </Link>
          </div>
        </div>

        {/* Contact Section */}
        <div className="mt-12">
          <p className="text-lg mb-4" style={{ color: '#708080' }}>
            Need help finding something specific?
          </p>
          <Link to="/contact">
            <Button 
              size="lg" 
              variant="outline"
              className="text-lg px-6 py-4"
              style={{ borderColor: '#606090', color: '#606090' }}
            >
              <Mail className="mr-2 h-5 w-5" />
              Contact Us
            </Button>
          </Link>
        </div>

        {/* Back Button */}
        <div className="mt-8">
          <Button 
            onClick={() => window.history.back()}
            variant="ghost"
            className="text-lg"
            style={{ color: '#708080' }}
          >
            <ArrowLeft className="mr-2 h-4 w-4" />
            Go Back
          </Button>
        </div>
      </div>
    </div>
  );
};
